import { createContext, useContext } from 'react'

/** Whether the live order stream (GET /api/live/stream) is open right now. */
export interface LiveStatus {
  connected: boolean
}

const DISCONNECTED: LiveStatus = Object.freeze({ connected: false })

/**
 * Provided once by Shell from useLiveEvents. Without a provider (tests, pages
 * rendered outside the shell) it reads as disconnected, so polling stays on.
 */
export const LiveStatusContext = createContext<LiveStatus>(DISCONNECTED)

/**
 * Order polls run only while this is false:
 * `refetchInterval: connected ? false : 30_000`.
 */
export function useLiveStatus(): LiveStatus {
  return useContext(LiveStatusContext)
}
